import { Box } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './badgeStyle.js'

export default function Badge(props) {
  const { color, children } = props
  return (
    <Box component={'span'} sx={[styles.badge, styles[color]]}>
      {children}
    </Box>
  )
}

Badge.propTypes = {
  color: PropTypes.oneOf([
    'primary',
    'warning',
    'danger',
    'success',
    'info',
    'rose',
    'gray',
  ]),
  children: PropTypes.node,
}
